import { useState, useRef, useEffect } from 'react';

const useOverflowDetector = deps => {
	const ref = useRef();
	const [overflowIndex, setOverflowIndex] = useState(null);

	useEffect(() => {
		if (!ref.current) {
			setOverflowIndex(null);
		} else {
			setOverflowIndex(checkChildrenOverflow(ref.current));
		}
	}, deps);

	return { ref, overflowIndex };
};

const checkChildrenOverflow = (element: HTMLElement) => {
	const children = Array.from(element.childNodes) as HTMLElement[];
	const index = children.findIndex(child => isOverflowing(element, child));

	return index > -1 ? index : null;
};

const isOverflowing = (parent, child) => {
	const childRect = child.getBoundingClientRect();
	const parentRect = parent.getBoundingClientRect();
	const offsetLeft = childRect.right - parentRect.left;
	const offsetTop = childRect.bottom - parentRect.top;
	return parentRect.width < offsetLeft || parentRect.height < offsetTop;
};

export default useOverflowDetector;
